import React, { useMemo } from 'react';
import _ from 'lodash';
import { useJobRemove, useJobs } from './jobs-provider';
import { Box, LinearProgress, List, ListItem, ListItemIcon, Stack, Typography, ListItemText, Card, CardHeader } from '@mui/material';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';

export function JobsList({ ...props }) {
  const { t } = useTranslation();
  const jobs = useJobs();
  const _jobs = _.map(jobs, (job, name) => ({ job, name })).reverse();

  return (
    <Card {...props}>
      <CardHeader title={t('DEVICES.DETAILS.JOBS_CARD.TITLE')} />
      <List sx={{
        marginX: 1,
        flexGrow: 1,
        "::-webkit-scrollbar": { display: 'none' },
        "msOverflowStyle": 'none',
        scrollbarWidth: 'none',
        overflowY: 'scroll', overflowX: 'hidden',
      }}>
        {_.map(_jobs, ({ name, job }) => {
          return <JobsItem key={name} name={name} job={job} />
        })}
      </List>
    </Card>
  )
}

export function useJobIconValue(job) {
  return useMemo(() => {
    let Icon, iconColor;
    let iconType = 'material-community';

    if (job.status === 'started') {
      iconColor = 'primary';
      Icon = (job.icon && job.icon.started) || ManageHistoryIcon;
    } else if (job.status === 'finished') {
      iconColor = 'success';
      Icon = (job.icon && job.icon.finished) || TaskAltIcon;
    } else {
      iconColor = 'error';
      Icon = (job.icon && job.icon.error) || ErrorOutlineIcon;
    }

    return { Icon, iconType, iconColor };
  }, [job.status]);
}

export function useJobProgressValue(job) {
  return useMemo(() => {
    return {
      progressValue: job.progress === null ? null : job.progress,
      progressVariant: job.progress === null ? 'indeterminate' : 'determinate',
      progressColor: job.status === 'error' ? 'error' : job.status === 'finished' ? 'success' : 'primary',
    }
  }, [job.progress, job.status]);
}

export function JobsItem({ job, name, ...props }) {

  const remove = useJobRemove();
  const { Icon, iconType, iconColor } = useJobIconValue(job);
  const { progressValue, progressVariant, progressColor } = useJobProgressValue(job);

  return (
    <ListItem divider>
      <ListItemIcon>
        <Icon color={iconColor} />
      </ListItemIcon>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <ListItemText primary={job.title || name} secondary={job.message} />
        <LinearProgress animation={'false'} value={progressValue} variant={progressVariant} color={progressColor} />
      </Stack>
    </ListItem>
  )
}
